import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SummernoteDirective} from './summernote.directive'
import {SummernoteAttachDirective} from './summernote-attach.directive'
import {SummernoteDetachDirective} from './summernote-detach.directive'

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    SummernoteDirective,
    SummernoteAttachDirective,
    SummernoteDetachDirective
  ],
  exports: [
    SummernoteDirective,
    SummernoteAttachDirective,
    SummernoteDetachDirective
  ]
})
export class SmartadminEditorsModule { }
